export default "__VITE_ASSET__2982d6f8__"